import React, { ReactNode } from 'react';
import styles from './HowItWorks.module.css';

interface FeaturesContainerProps {
  children: ReactNode;
}

const FeaturesContainer: React.FC<FeaturesContainerProps> = ({ children }) => {
  return (
    <div className={styles.container}>
      {children}
    </div>
  );
};

export default FeaturesContainer; 